import React, { useEffect, useState } from 'react';

import { OTP_RESEND_WAIT_TIME_IN_SECONDS } from '../../Modal/WhatsappVerificationModal/consts';
import { WhatsappVerificationStep } from '../types';
import { WhatsappVerificationContext } from './WhatsappVerificationContext';

type Props = {
  children: React.ReactNode;
  initialStep?: WhatsappVerificationStep;
};

export const WhatsappVerificationContextProvider = ({
  children,
  initialStep,
}: Props) => {
  const [currentStep, setCurrentStep] = useState<WhatsappVerificationStep>(
    initialStep || WhatsappVerificationStep.InputNumber
  );
  const [stepHistory, setStepHistory] = useState<WhatsappVerificationStep[]>(
    []
  );

  const [loading, setLoading] = useState(false);

  const [resendOTPCountdown, setResendOTPCountdown] = useState(
    OTP_RESEND_WAIT_TIME_IN_SECONDS
  );

  useEffect(() => {
    if (currentStep !== WhatsappVerificationStep.InputOTP) {
      return;
    }

    if (resendOTPCountdown === 0) {
      return;
    }

    const timer = setTimeout(() => {
      setResendOTPCountdown(resendOTPCountdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [resendOTPCountdown, currentStep]);

  const nextStep = () => {
    if (currentStep === WhatsappVerificationStep.VerificationSuccess) {
      return;
    }
    if (currentStep === WhatsappVerificationStep.ConfirmWhatsappNumber) {
      setCurrentStep(WhatsappVerificationStep.InputOTP);
      setStepHistory([...stepHistory, WhatsappVerificationStep.InputOTP]);

      return;
    }
    const nextStep = (currentStep + 1) as WhatsappVerificationStep;
    setCurrentStep(nextStep);
    setStepHistory([...stepHistory, nextStep]);
  };

  const previousStep = () => {
    if (
      currentStep === WhatsappVerificationStep.InputNumber ||
      currentStep === WhatsappVerificationStep.ConfirmWhatsappNumber
    ) {
      return;
    }
    if (
      currentStep === WhatsappVerificationStep.InputOTP &&
      initialStep === WhatsappVerificationStep.ConfirmWhatsappNumber
    ) {
      setCurrentStep(WhatsappVerificationStep.ConfirmWhatsappNumber);
      setStepHistory([
        ...stepHistory,
        WhatsappVerificationStep.ConfirmWhatsappNumber,
      ]);
      return;
    }

    const previousStep = (currentStep - 1) as WhatsappVerificationStep;
    setCurrentStep(previousStep);
    setStepHistory([...stepHistory, previousStep]);
  };

  return (
    <WhatsappVerificationContext.Provider
      value={{
        currentStep,
        stepHistory,
        nextStep,
        previousStep,
        setCurrentStep,
        loading,
        setLoading,
        resendOTPCountdown,
        setResendOTPCountdown,
      }}
    >
      {children}
    </WhatsappVerificationContext.Provider>
  );
};
